import { render, staticRenderFns } from "./SettingWalletTruewallet.vue?vue&type=template&id=6ac794d4"
import script from "./SettingWalletTruewallet.vue?vue&type=script&lang=js"
export * from "./SettingWalletTruewallet.vue?vue&type=script&lang=js"
import style0 from "./SettingWalletTruewallet.vue?vue&type=style&index=0&id=6ac794d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports